import { createBrowserRouter, RouterProvider } from "react-router";
import { Layout } from "./Layout";
import { HomePage } from "@/Pages/Home";
import { PhotoBoothPage } from "@/Pages/PhotoBooth";
import { ResultPage } from "@/Pages/Result";
import { FramesPage } from "@/Pages/Frames";
import { FrameDetailPage } from "@/Pages/FrameDetail";
import { CameraPage } from "@/Pages/Camera";
import { AboutUsPage } from "@/Pages/AboutUs";
import { TermsAndPrivacyPolicyPage } from "@/Pages/TermsAndPrivacyPolicy";
import { ErrorPage } from "@/Pages/Error";
import { PaymentPage } from "@/Pages/Payment";
import { HistoryPage } from "@/Pages/History";
import { RecoverPage } from "@/Pages/Recover";

const router = createBrowserRouter([
  {
    path: "/",
    element: <Layout />,
    children: [
      {
        index: true,
        element: <HomePage />,
      },
      {
        path: "photo-booth",
        element: <PhotoBoothPage />,
      },
      {
        path: "camera",
        element: <CameraPage />,
      },
      {
        path: "result",
        element: <ResultPage />,
      },
      {
        path: "frame",
        element: <FramesPage />,
      },
      {
        path: "frame-detail",
        element: <FrameDetailPage />,
      },
      {
        path: "payment",
        element: <PaymentPage />,
      },
      {
        path: "history",
        element: <HistoryPage />,
      },
      {
        path: "recover",
        element: <RecoverPage />,
      },
      {
        path: "about-us",
        element: <AboutUsPage />,
      },
      {
        path: "terms-and-privacy-policy",
        element: <TermsAndPrivacyPolicyPage />,
      },
      {
        path: "error",
        element: <ErrorPage />,
      },
    ],
    errorElement: <ErrorPage />,
  },
]);

const App = () => (
  <>
    <RouterProvider router={router} />
  </>
);

export default App;